export const projects = [
  {
    title: "Scrum Web / Mobile application",
    description:
      "My Final Year Project , researched on Scrum Methodology and developed a Scrum board application for beginners",
    languages: ["React", "React Native", "Firebase", "Onesignal"],
  },
  {
    title: "Long Property",
    description: "Revamping the website of a property development company",
    languages: ["HTML", "CSS", "JS"],
    external: "https://www.longproperty.com.my/",
  },
  {
    title: "Coziebear",
    description:
      "Working on the front-end of a mobile tenant application, which allows the tenant to keep track all the important tenancy stuffs, documents and contracts. The tenants could also use this app to lodge a maintenance issue",
    languages: ["React Native"],
    external: "https://www.facebook.com/coziebear.iconix/",
  },
  {
    title: "PortfolioV1",
    description:
      "My first portfolio website I designed and developed using React & Material UI backed in 2020. Since then, i enhanced my skill in responsive web design using HTML , CSS and JS.",
    languages: ["React", "Material UI"],
    external: "https://lowzijian.github.io/Portfolio/",
  },
];
